<template>
	<div class="video-medium-teaser medium-teaser teaser row fast">
		<div class="small-6 medium-12 columns">
			<a :href="video.url">
				<div class="video-teaser rel loader small-icon icon-only">
					<div class="logo-inner">
						<img v-icon.literal="../logo-mobile.svg" class="logo"/>
					</div>
					<img :src="imageUrl" v-if="imageLoaded" class="image fast" transition="motion-ui" data-in="fade-in" />
					<div class="overlay-gallery-std nohover visible">
						<div class="flex-container">
							<div>
								<img v-icon.literal="play.svg" alt="Play" class="icon" />
							</div>
						</div>
					</div>
				</div>
			</a>
		</div>
		<div class="small-6 medium-12 columns">
			<h4><a :href="video.url">{{ video.title | truncate 50 }}
				<span class="small inactive" v-if="date"><br />{{ date }}</span></a></h4>
			<div class="links bot-border bot-buffer">
				<div class="blue" v-if="category">
					<a :href="category.url">{{ category.title }}</a>
				</div>
				<span>
					<!-- views -->
					<span :data-ot="shareLinkText" data-ot-target="true" data-ot-style="sharetip" class="share-link">Share</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'underscore'
	import moment from 'moment'
	export default {
		props: ['video', 'categoryTid'],
		data() {
			return {
				imageLoaded: false
			};
		},
		ready: function () {

			// Find elements.
			window.ABR.ReOpenTip();

			if (!this.imageUrl) return;

			// Load the image.
			var img = new Image();
			img.src = this.imageUrl;
			img.onload = function () {
				this.imageLoaded = true;
			}.bind(this);

		},
		computed: {
			imageUrl: function () {
				if (!this.video.image) return '';
				return this.video.image.file.styles.small_thumbnail_16_9;
			},
			category: function () {
				if (this.categoryTid) {
					return _.findWhere(this.video.category, { id: this.categoryTid }) || _.last(this.video.category);
				} else {
					return _.last(this.video.category);
				}
			},
			date: function () {
				if (!this.video.date) return false;
				return moment(this.video.date).format('MMMM DD, YYYY');
			},
			shareLinkText: function () {

				// Render the template.
				var template = '<a data-share-<%= type %> data-share-url="<%= url %>" data-share-text="<%= title %>" href="#"><img src="<%= socialBase %>/<%= type %>.svg" alt="<%= type %>" class="svg" /></a>';
				var services = ['twitter', 'facebook', 'pinterest'];
				var rendered = [];
				var replacements = {
					url: this.video.url,
					title: this.video.title,
					socialBase: window.Drupal.settings.abr_general.theme_path + '/img/icons/social/'
				};
				_.each(services, function (service) {
					replacements.type = service;
					var html = _.template(template)(replacements);
					rendered.push(html);
				});

				// Convert to special characters.
				return '<div class="share-links-tooltip">' + rendered.join(' ') + '</div>';

			}
		},
		methods: {
			imageLoadedEvent: function () {
				this.imageLoaded = true;
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** Video.vue?1f9edcab
 **/